
<script>
    import { selectedItem } from '../../../store/store.js';
    import { displayInt } from '../../../utils/utils.js';
</script>

<div class="key-value-table box">
    <h5>Byggnadsinformation</h5>
    <table>
        <colgroup>
            <col style="width: 65%;">
            <col style="width: 30%;">
            <col style="width: 5%;">
        </colgroup>
        <tbody>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Byggnadstyp</h6>
                </td>
                <td class="column2">
                <h6>{ $selectedItem.byggnadstyp }</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Skyddad som byggnadsminne</h6>
                </td>
                <td class="column2">
                <h6>{ $selectedItem.building_protected_against_building_memory }</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            {#each $selectedItem.business_distribution as business}
                <tr class="row100 body">
                    <td class="column1">
                        <h6>{ business.business_name }</h6>
                    </td>
                    <td class="column2">
                    <h6>{ displayInt(Math.ceil(($selectedItem.atemp * 0.01) * business.percentage_of_atemp)) } kvm</h6>
                    </td>
                    <td class="column3">
                    </td>
                </tr>
            {/each}
        </tbody>
    </table>
</div>